/* eslint-disable eqeqeq */
import { useState, useEffect } from "react";

import OutsideClickHandler from "react-outside-click-handler";

import {
  SelectWrapper,
  SelectedOptionWrapper,
  SelectLists,
  SelectList,
} from "./select.style";

export default function Select({
  selected,
  options,
  setSelected,
  index,
  thirdOption,
  title,
  onClick,
  disabled,
  readonly,
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {}, [open]);
  
  return (
    <SelectWrapper
      className={(disabled || readonly) ? "disabled" : ""}
      style={{
        pointerEvents: (disabled || readonly) ? "none" : "",
        opacity: readonly ? 1 : "",
        cursor: readonly ? "default" : "",
      }}
      onClick={() => {
        if (!readonly && !disabled) { 
          setOpen(!open);
        }
      }}
    >
      <SelectedOptionWrapper>
        {selected ? (
          options
            .filter(
              (option) =>
                option.id == selected ||
                option[index] == selected ||
                option[thirdOption] == selected
            )
            .map((item, i) => <p key={i}>{item[index]}</p>)
        ) : (
          <span>Select {title}</span>
        )}
      </SelectedOptionWrapper>
      
      {/* Always render the dropdown list but control visibility */}
      <OutsideClickHandler onOutsideClick={() => !readonly && setOpen(false)}>
        <SelectLists hide={!open} style={{ display: readonly ? "none" : undefined }}>
          {options &&
            options.map((item) => {
              let active = false;
              if (selected && selected[index] === item[index]) {
                active = true;
              }
              return (
                <SelectList
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!readonly) {
                      setSelected(item);
                      setOpen(false);
                      if (onClick) {
                        onClick();
                      }
                    }
                  }}
                  key={item[index]}
                  active={active}
                >
                  {item[index]}
                </SelectList>
              );
            })}
        </SelectLists>
      </OutsideClickHandler>
    </SelectWrapper>
  );
}